import React, { useEffect, useState } from 'react';
import { Button, Spinner } from '@fluentui/react-components';
import { useMarketing } from './MarketingContext';
import { MarketingGrid } from './MarketingGrid';
import { TileEditor } from './TileEditor';

export const MarketingAdminPanel = (): JSX.Element => {
  const {
    draftTiles,
    updatedAt,
    updatedBy,
    loading,
    saving,
    error,
    dirty,
    load,
    addTile,
    updateTile,
    removeTile,
    resetDraft,
    save
  } = useMarketing();
  const [preview, setPreview] = useState(false);

  useEffect(() => {
    void load();
  }, [load]);

  return (
    <div className="marketing-admin">
      <div className="marketing-admin-header">
        <div>
          <h2 className="section-title">Marketing content</h2>
          <p className="muted">
            Manage tiles for portal and public surfaces. Last update: {updatedAt ?? '—'}
            {updatedBy ? ` by ${updatedBy}` : ''}
          </p>
        </div>
        <div className="marketing-admin-actions">
          <Button appearance="secondary" onClick={() => void load()} disabled={loading}>
            Refresh
          </Button>
          <Button appearance="secondary" onClick={() => setPreview((current) => !current)}>
            {preview ? 'Hide preview' : 'Preview'}
          </Button>
          <Button appearance="secondary" onClick={resetDraft} disabled={!dirty}>
            Discard changes
          </Button>
          <Button appearance="primary" onClick={() => void save()} disabled={!dirty || saving}>
            {saving ? 'Publishing…' : 'Publish'}
          </Button>
        </div>
      </div>

      {error && <div className="pill warning">{error}</div>}
      {loading && (
        <div className="marketing-loading">
          <Spinner />
          <span>Loading marketing tiles…</span>
        </div>
      )}

      <div className="marketing-admin-grid">
        <div>
          <div className="marketing-admin-toolbar">
            <Button appearance="primary" onClick={addTile}>
              Add tile
            </Button>
            <span className="muted">
              {dirty ? 'Unsaved changes' : 'All changes published'}
            </span>
          </div>
          {draftTiles.map((tile) => (
            <TileEditor
              key={tile.id}
              tile={tile}
              onChange={(patch) => updateTile(tile.id, patch)}
              onRemove={() => removeTile(tile.id)}
            />
          ))}
          {draftTiles.length === 0 && (
            <div className="card marketing-empty">
              <p className="muted">No tiles yet. Add the first marketing tile.</p>
            </div>
          )}
        </div>
        {preview && (
          <div>
            <h3 className="section-title">Preview</h3>
            <MarketingGrid tiles={draftTiles} />
          </div>
        )}
      </div>
    </div>
  );
};
